import React, { useState, MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';

export function usePayNotice(defaultChecked = true) {
  const history = useHistory();
  const [checked, setChecked] = useState(defaultChecked);
  function toggle() {
    setChecked((prev) => {
      return !prev;
    });
  }

  // const dom = (
  //   <label className="weui-cell weui-cell_active weui-check__label" onClick={toggle}>
  //     <div className="weui-cell__hd">
  //       <input checked={checked} type="checkbox" name="checkbox1" className="weui-check" />
  //       {/*<i className="weui-icon-checked"></i>*/}
  //     </div>
  //     <div className="weui-cell__bd">
  //       <p>小学僮会员服务协议</p>
  //     </div>
  //   </label>
  // );

  function viewVipNotice(e: MouseEvent<HTMLSpanElement>) {
    history.push('/mp/compliance/vipNotice');
    e.stopPropagation();
  }

  const dom = (
    <div onClick={toggle} style={{color: 'gray', textAlign: 'center', marginTop: 10}}>
      <input checked={checked} type="checkbox" name="checkbox1" />
      <span onClick={viewVipNotice}>《小学僮会员服务协议》</span>
    </div>
  );

  return {
    checked,
    toggle,
    viewVipNotice,
    vipNoticeDom: dom,
  };
}
